import { render, staticRenderFns } from "./TabPlaylist.vue?vue&type=template&id=39f49f91&scoped=true"
import script from "./TabPlaylist.vue?vue&type=script&lang=js"
export * from "./TabPlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f49f91",
  null
  
)

export default component.exports